<div #container class="row">
  <div class="column" *ngFor="let twoBlock of blocks">
    <div *ngFor="let block of twoBlock">
      <app-card [title]="block.title" *ngIf="!block.locked" headerTitleClass="{{ isDisable() ? 'danger' : ''}}">
        <div class="card-block-hid ng-trigger ng-trigger-cardToggle ql-container" style="overflow: hidden;">
          <div class="ql-editor p-0" [innerHTML]="block.content | safe:'html'"></div>
        </div>
      </app-card>
      <app-card *ngIf="block.locked" [title]="block.title" headerTitleClass="{{ isDisable() ? 'danger' : ''}}">
        <div class="card-block-hid ng-trigger ng-trigger-cardToggle ql-container" style="overflow: hidden;">
          <div class="ql-editor pt-0 pe-0 ps-0" [innerHTML]="block.content | safe:'html'"></div>
        </div>
        <app-order-grid [grid]="grid"></app-order-grid>
      </app-card>
    </div>
  </div>
</div>
